import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import uuidv1 from 'uuid/v1';
import { CSSTransition } from 'react-transition-group';
import GameSelectorStyled, {
  GameSelectorWindow,
  GameSelectorList,
  GameSelectorPanel,
  GameArticle,
  GameDefList,
  GameArticleIndent,
  GameArticleIntro,
  GameDD,
  GameDT,
} from './GameSelector.styled';
import GameSelectorNav from '../../molecules/GameSelectorNav/GameSelectorNav';
import GameButton from '../../atoms/GameButton/GameButton';
import GameArticleTitle from '../../atoms/GameArticleTitle/GameArticleTitle';
import GameArticleStars from '../../atoms/GameArticleStars/GameArticleStars';
import SVGPathBG from '../../atoms/SVGPathBG/SVGPathBG';
import StarsCollected from '../../atoms/StarsCollected/StarsCollected';
import { splitAndSpanString } from '../../../helpers/splitAndSpanString';
import { safeCatch } from '../../../helpers/safeCatch';

const mapStateToProps = state => ({
  gameData: state.gameData,
  gameLevel: state.saved.gameLevel,
  unlockedLevels: state.saved.unlockedLevels,
  savedBest: state.saved.best,
  countUp: state.settings.countUp,
  countDown: state.settings.countDown,
});

const GameSelector = ({
  viewing,
  gameData,
  gameLevel,
  savedBest,
  unlockedLevels,
  countDown,
  countUp,
}) => {
  const gamesTotal = gameData.length;
  return (
    <GameSelectorStyled
      viewing={viewing}
      aria-hidden={viewing ? 'false' : 'true'}
    >
      <GameSelectorWindow>
        <GameSelectorNav />
        <GameSelectorList
          id="game-list"
          currentGame={gameLevel}
          listWidth={gamesTotal}
        >
          {gameData.map((game, index) => (
            <GameSelectorPanel data-game-panel key={uuidv1()}>
              <SVGPathBG svg={game.path.horz} level={index} />
              <CSSTransition
                in={gameLevel === index}
                appear
                timeout={500}
                classNames="game"
              >
                <section className="game" key={uuidv1()}>
                  <GameArticle gameTheme={index} id={`game-${index + 1}`}>
                    <GameArticleIndent gameTheme={index}>
                      <GameArticleTitle gameTheme={index} level={index + 1} />
                      <GameArticleStars
                        PB
                        stars={() =>
                          savedBest[index].starCount
                            ? savedBest[index].starCount
                            : 0
                        }
                      />
                      <GameArticleIntro>
                        {splitAndSpanString(
                          game.title ? game.title : `Level ${index + 1}`
                        )}
                      </GameArticleIntro>
                      {countDown && (
                        <GameDefList>
                          <GameDT>Time</GameDT>
                          <GameDD>
                            {game.time}
                            <small>s</small>
                          </GameDD>
                        </GameDefList>
                      )}
                      {safeCatch(() => savedBest[index].timeTaken) &&
                      countUp &&
                      !countDown ? (
                        savedBest[index].timeTaken !== 99999 ? (
                          <GameDefList>
                            <GameDT title="Personal Best">PB</GameDT>
                            <GameDD>
                              {savedBest[index].timeTaken}
                              <small>s</small>
                            </GameDD>
                          </GameDefList>
                        ) : (
                          <GameDefList>
                            <GameDT title="Personal Best">PB</GameDT>
                            <GameDD title="locked">--</GameDD>
                          </GameDefList>
                        )
                      ) : (
                        ''
                      )}
                      <GameButton
                        level={index}
                        locked={unlockedLevels < index}
                      />
                    </GameArticleIndent>
                  </GameArticle>
                </section>
              </CSSTransition>
            </GameSelectorPanel>
          ))}
        </GameSelectorList>
        <StarsCollected />
      </GameSelectorWindow>
    </GameSelectorStyled>
  );
};

export default connect(mapStateToProps)(GameSelector);

GameSelector.propTypes = {
  gameLevel: PropTypes.number.isRequired,
  unlockedLevels: PropTypes.number.isRequired,
  viewing: PropTypes.bool.isRequired,
  savedBest: PropTypes.arrayOf(PropTypes.object).isRequired,
  gameData: PropTypes.arrayOf(
    PropTypes.shape({
      locked: PropTypes.bool,
      best: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      time: PropTypes.number,
    })
  ).isRequired,
};



// WEBPACK FOOTER //
// ./src/components/organisms/GameSelector/GameSelector.js